import React from 'react';

import {keys} from 'lodash';
import {useParams} from 'react-router';
import {FormGroup, CustomInput, FormFeedback, Label} from 'reactstrap';

import {REGEXP_FEEDBACK} from 'configs';
import {AB_ENQUIRY_TYPE} from 'configs/types';
import {SelectBranch} from 'components/Forms/Selects';
import PublicContact from 'components/Publics/PublicContactNew';

import styles from './styles.module.scss';

function ABContact() {
  const {abId} = useParams();

  return (
    <section>
      <h3 className={styles['section__title']}>Contact us</h3>
      <PublicContact
        companyType="ab"
        companyId={abId}
        description="Get in touch with this Accreditation Body"
      >
        <FormGroup>
          <Label>Select Branch</Label>

          <SelectBranch
            id={abId}
            companyType="ab"
            className="text-black"
            name="enquires_recv_company_id"
            required
          />
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label>Enquiry Category</Label>

          <CustomInput
            id="enquiry_category"
            type="select"
            name="enquires_category"
            required
          >
            {keys(AB_ENQUIRY_TYPE).map((key, index) => (
              <option key={index} value={key}>
                {AB_ENQUIRY_TYPE[key]}
              </option>
            ))}
          </CustomInput>
          <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
        </FormGroup>
      </PublicContact>
    </section>
  );
}

export default ABContact;
